webpackJsonp([11,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _redirectUrl = __webpack_require__(14);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(406);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueAwesomeSwiper = __webpack_require__(17);
	
	var _vueAwesomeSwiper2 = _interopRequireDefault(_vueAwesomeSwiper);
	
	__webpack_require__(15);
	
	__webpack_require__(10);
	
	var _toast = __webpack_require__(8);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _redirectUrl.redirectFun)('video');
	
	
	_vue2.default.use(_vueAwesomeSwiper2.default);
	_vue2.default.use(_toast2.default);
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.infoDetails = infoDetails;
	exports.infoSnap = infoSnap;
	exports.infoContentSnap = infoContentSnap;
	exports.infoComment = infoComment;
	exports.infoCommentReply = infoCommentReply;
	exports.infoContentDel = infoContentDel;
	exports.newsSnap = newsSnap;
	exports.newsContentSnap = newsContentSnap;
	exports.newsContentSnapCancle = newsContentSnapCancle;
	exports.newsAddComment = newsAddComment;
	exports.newsCommentReply = newsCommentReply;
	exports.newsCommentDel = newsCommentDel;
	exports.delInfo = delInfo;
	exports.newsDetails = newsDetails;
	exports.videoDetails = videoDetails;
	exports.praiseFlag = praiseFlag;
	exports.liveDetails = liveDetails;
	exports.newsCommentList = newsCommentList;
	exports.thematicDetails = thematicDetails;
	exports.index = index;
	exports.atlasDetails = atlasDetails;
	exports.getToken = getToken;
	exports.getAccessToken = getAccessToken;
	exports.shareUrl = shareUrl;
	exports.getCode = getCode;
	exports.getUserInfo = getUserInfo;
	exports.submit = submit;
	exports.getActUrl = getActUrl;
	exports.liveMain = liveMain;
	exports.upLoadImg = upLoadImg;
	exports.sendInfo = sendInfo;
	exports.ydTop = ydTop;
	exports.ydIndex = ydIndex;
	exports.wbBanner = wbBanner;
	exports.wbChannel = wbChannel;
	exports.channelNews = channelNews;
	exports.hotList = hotList;
	exports.hotNum = hotNum;
	exports.starNewsList = starNewsList;
	exports.thinkTankDetails = thinkTankDetails;
	
	var _request = __webpack_require__(7);
	
	var _request2 = _interopRequireDefault(_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function infoDetails(data) {
	  return (0, _request2.default)({
	    url: '/shareIntelligence.do',
	    method: 'post',
	    data: data
	  });
	}
	function infoSnap(data) {
	  return (0, _request2.default)({
	    url: '/interestedShareIntelligence.do',
	    method: 'post',
	    data: data
	  });
	}
	function infoContentSnap(data) {
	  return (0, _request2.default)({
	    url: '/likeShareIntelligenceComment.do',
	    method: 'post',
	    data: data
	  });
	}
	function infoComment(data) {
	  return (0, _request2.default)({
	    url: '/sharenewsource_comment_add.do',
	    method: 'post',
	    data: data
	  });
	}
	function infoCommentReply(data) {
	  return (0, _request2.default)({
	    url: '/sharenewsource_comment_second.do',
	    method: 'post',
	    data: data
	  });
	}
	function infoContentDel(data) {
	  console.log('ada', data);
	  return (0, _request2.default)({
	    url: '/deleteShareIntelligenceComment.do',
	    method: 'post',
	    data: data
	  });
	}
	function newsSnap(data) {
	  return (0, _request2.default)({
	    url: '/sharenews_praise.do',
	    method: 'post',
	    data: data
	  });
	}
	function newsContentSnap(data) {
	  return (0, _request2.default)({
	    url: '/sharenewscomment_praise.do',
	    method: 'post',
	    data: data
	  });
	}
	function newsContentSnapCancle(data) {
	  return (0, _request2.default)({
	    url: '/sharenewscomment_praise_cancle.do',
	    method: 'post',
	    data: data
	  });
	}
	function newsAddComment(data) {
	  return (0, _request2.default)({
	    url: '/sharenews_comment_add_lev1.do',
	    method: 'post',
	    data: data
	  });
	}
	
	function newsCommentReply(data) {
	  return (0, _request2.default)({
	    url: '/sharenews_comment_add_lev2.do',
	    method: 'post',
	    data: data
	  });
	}
	function newsCommentDel(data) {
	  return (0, _request2.default)({
	    url: '/sharenewscomment_opt.do',
	    method: 'post',
	    data: data
	  });
	}
	function delInfo(data) {
	  return (0, _request2.default)({
	    method: 'post',
	    data: data
	  });
	}
	function newsDetails(data) {
	  return (0, _request2.default)({
	    url: '/getsharedcommonnewsdetailinfo.do',
	    method: 'post',
	    data: data
	  });
	}
	function videoDetails(data) {
	  return (0, _request2.default)({
	    url: '/getsharedvideodetail.do',
	    method: 'post',
	    data: data
	  });
	}
	
	function praiseFlag(data) {
	  return (0, _request2.default)({
	    url: '/praiseFlag.do',
	    method: 'post',
	    data: data
	  });
	}
	function liveDetails(data) {
	  return (0, _request2.default)({
	    url: '/getsharedvideolivedetail.do',
	    method: 'post',
	    data: data
	  });
	}
	function newsCommentList(data) {
	  return (0, _request2.default)({
	    url: '/sharenewscomment.do',
	    method: 'post',
	    data: data
	  });
	}
	function thematicDetails(data) {
	  return (0, _request2.default)({
	    url: '/getsharedsubjectdetailnews.do',
	    method: 'post',
	    data: data
	  });
	}
	function index(data) {
	  return (0, _request2.default)({
	    url: '/shareMainPage.do',
	    method: 'post',
	    data: data
	  });
	}
	function atlasDetails(data) {
	  return (0, _request2.default)({
	    url: '/shareimgnews_content.do',
	    method: 'post',
	    data: data
	  });
	}
	function getToken(data) {
	  return (0, _request2.default)({
	    url: '/shareIdentify.do',
	    method: 'post',
	    data: data
	  });
	}
	function getAccessToken(data) {
	  return (0, _request2.default)({
	    url: '/getAccessToken.do',
	    method: 'post',
	    data: data
	  });
	}
	function shareUrl(data) {
	  return (0, _request2.default)({
	    url: '/get_page_config.do',
	    method: 'post',
	    data: data
	  });
	}
	function getCode(data) {
	  return (0, _request2.default)({
	    url: '/jfshop/selectusercode.do',
	    method: 'post',
	    data: data
	  });
	}
	function getUserInfo(data) {
	  return (0, _request2.default)({
	    url: '/user_info.do',
	    method: 'post',
	    data: data
	  });
	}
	function submit(data) {
	  return (0, _request2.default)({
	    url: '/jfshop/addregcode.do',
	    method: 'post',
	    data: data
	  });
	}
	
	function getActUrl(data) {
	  return (0, _request2.default)({
	    url: '/active_info.do',
	    method: 'post',
	    data: data
	  });
	}
	
	function liveMain(data) {
	  return (0, _request2.default)({
	    url: '/getshareanchorhall.do',
	    method: 'post',
	    data: data
	  });
	}
	function upLoadImg(data) {
	  return (0, _request2.default)({
	    url: '/getshareanchorhall.do',
	    method: 'post',
	    data: data
	  });
	}
	function sendInfo(data) {
	  return (0, _request2.default)({
	    url: '/addShareIntelligence.do',
	    method: 'post',
	    data: data
	  });
	}
	function ydTop(data) {
	  return (0, _request2.default)({
	    url: '/getsubchannelbase.do',
	    method: 'post',
	    data: data
	  });
	}
	function ydIndex(data) {
	  return (0, _request2.default)({
	    url: '/shareSubChannelNews.do',
	    method: 'post',
	    data: data
	  });
	}
	function wbBanner(data) {
	  return (0, _request2.default)({
	    url: '/getnewbannerlist.do',
	    method: 'post',
	    data: data
	  });
	}
	function wbChannel(data) {
	  return (0, _request2.default)({
	    url: '/qlwbChannelList.do',
	    method: 'post',
	    data: data
	  });
	}
	function channelNews(data) {
	  return (0, _request2.default)({
	    url: '/shareSubChannelNews.do',
	    method: 'post',
	    data: data
	  });
	}
	function hotList(data) {
	  return (0, _request2.default)({
	    url: '/getNewsRankInfoList.do',
	    method: 'post',
	    data: data
	  });
	}
	
	function hotNum(data) {
	  return (0, _request2.default)({
	    url: '/getNewsRankNoByNewsId.do',
	    method: 'post',
	    data: data
	  });
	}
	function starNewsList(data) {
	  return (0, _request2.default)({
	    url: '/getAnchorVideoDetailInfo.do',
	    method: 'post',
	    data: data
	  });
	}
	function thinkTankDetails(data) {
	  return (0, _request2.default)({
	    url: '/getThinkReprotInfo.do',
	    method: 'post',
	    data: data
	  });
	}

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function getUrlParam(name) {
	  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	  var r = window.location.search.substr(1).match(reg);
	  if (r != null) return unescape(r[2]);
	  return null;
	}
	function confirm(message) {
	  var iframe = document.createElement("IFRAME");
	  iframe.style.display = "none";
	  iframe.setAttribute("src", 'data:text/plain,');
	  document.documentElement.appendChild(iframe);
	  var alertFrame = window.frames[0];
	  var result = alertFrame.window.confirm(message);
	  iframe.parentNode.removeChild(iframe);
	  return result;
	}
	function startMover() {
	  var commentInput = document.getElementsByClassName("commentInput")[0];
	  var x = document.body.clientX || document.documentElement.clientX;
	  var sT = document.body.scrollTop || document.documentElement.scrollTop;
	
	  var y = commentInput.offsetTop + sT;
	
	  var star = document.createElement("div");
	  star.innerText = "❤";
	  var RandomSize = parseInt(Math.random() * 25 + 25);
	  star.style.height = star.style.width = RandomSize + "px";
	  star.style.color = '#E51C23';
	  star.style.fontSize = RandomSize + "px";
	  star.style.position = "absolute";
	  star.style.right = 22 + "px";
	  star.style.top = y + "px";
	  document.body.appendChild(star);
	  var op = 100;
	  var deg = 0;
	  var RandomX = Math.round(Math.random() * 13 + 2);
	  var t = setInterval(function () {
	    op--;
	    deg += 5;
	    star.style.top = star.offsetTop - RandomX + "px";
	    star.style.right = 50 * Math.sin(deg * Math.PI / 180) + x + "px";
	    star.style.opacity = op / 100;
	    if (star.style.opacity == 0) {
	      clearInterval(t);
	      star.remove();
	    }
	  }, 20);
	}
	function scriptFun() {
	  var hm = document.createElement("script");
	  hm.src = "https://hm.baidu.com/hm.js?a6dc1757a16356d0d1df93208a984704";
	  var s = document.getElementsByTagName("script")[0];
	  s.parentNode.insertBefore(hm, s);
	}
	
	
	var configData = {
	  jumpUrl: 'https://m.ql1d.com/share/module' };
	function isAndroid() {
	  var u = navigator.userAgent;
	  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
	  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
	  if (isAndroid) {
	    return true;
	  } else if (isiOS) {
	    return false;
	  }
	};
	exports.getUrlParam = getUrlParam;
	exports.startMover = startMover;
	exports.confirm = confirm;
	exports.scriptFun = scriptFun;
	exports.configData = configData;
	exports.isAndroid = isAndroid;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(22);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(21);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = request;
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var service = {
	  baseURL: 'https://api.qiluyidian.mobi/qlwb',
	  timeout: 15000,
	  headers: { 'Content-Type': 'text/plain;charset=UTF-8' }
	};
	function request(req) {
	  if (req.url) {
	    var config = (0, _assign2.default)({}, service, req);
	
	    if (!config.params) {
	      config.params = {};
	    }
	
	    config.params.timestamp = new Date().getTime();
	
	    if (config.data.tokenID) {
	      config.params.tokenID = config.data.tokenID;
	    }
	
	    return new _promise2.default(function (resole, reject) {
	      _axios2.default.request(config).then(function (res) {
	        if (res.status !== 200) {
	          reject(res);
	        } else {
	          resole(res);
	        }
	      }).catch(function (err) {
	        reject(err);
	      });
	    });
	  }
	}

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

	'use strict';
	
	var Toast = {};
	var showToast = false,
	    showLoad = false,
	    toastVM = null,
	    loadNode = null;
	
	Toast.install = function (Vue, options) {
	  var opt = {
	    defaultType: 'bottom',
	    duration: '2000',
	    wordWrap: false
	  };
	  for (var property in options) {
	    opt[property] = options[property];
	  }
	
	  Vue.prototype.$toast = function (tips, type) {
	
	    var curType = type ? type : opt.defaultType;
	    var wordWrap = opt.wordWrap ? 'lx-word-wrap' : '';
	    var style = opt.width ? 'style="width: ' + opt.width + '"' : '';
	    var tmp = '<div v-show="show" :class="type" class="lx-toast ' + wordWrap + '" ' + style + '>{{tip}}</div>';
	
	    if (showToast) {
	      return;
	    }
	    if (!toastVM) {
	      var toastTpl = Vue.extend({
	        data: function data() {
	          return {
	            show: showToast,
	            tip: tips,
	            type: 'lx-toast-' + curType
	          };
	        },
	        template: tmp
	      });
	      toastVM = new toastTpl();
	      var tpl = toastVM.$mount().$el;
	      document.body.appendChild(tpl);
	    }
	    toastVM.type = 'lx-toast-' + curType;
	    toastVM.tip = tips;
	    toastVM.show = showToast = true;
	
	    setTimeout(function () {
	      toastVM.show = showToast = false;
	    }, opt.duration);
	  };
	
	  ['bottom', 'center', 'top'].forEach(function (type) {
	    Vue.prototype.$toast[type] = function (tips) {
	      return Vue.prototype.$toast(tips, type);
	    };
	  });
	
	  Vue.prototype.$loading = function (tips, type) {
	    if (type == 'close') {
	      loadNode.show = showLoad = false;
	    } else {
	      if (showLoad) {
	        return;
	      }
	      var loadTpl = Vue.extend({
	        data: function data() {
	          return {
	            show: showLoad
	          };
	        },
	        template: '<div v-show="show" class="lx-load-mark"><div class="lx-load-box"><div class="lx-loading"><div class="loading_leaf loading_leaf_0"></div><div class="loading_leaf loading_leaf_1"></div><div class="loading_leaf loading_leaf_2"></div><div class="loading_leaf loading_leaf_3"></div><div class="loading_leaf loading_leaf_4"></div><div class="loading_leaf loading_leaf_5"></div><div class="loading_leaf loading_leaf_6"></div><div class="loading_leaf loading_leaf_7"></div><div class="loading_leaf loading_leaf_8"></div><div class="loading_leaf loading_leaf_9"></div><div class="loading_leaf loading_leaf_10"></div><div class="loading_leaf loading_leaf_11"></div></div><div class="lx-load-content">' + tips + '</div></div></div>'
	      });
	      loadNode = new loadTpl();
	      var tpl = loadNode.$mount().$el;
	
	      document.body.appendChild(tpl);
	      loadNode.show = showLoad = true;
	    }
	  };
	
	  ['open', 'close'].forEach(function (type) {
	    Vue.prototype.$loading[type] = function (tips) {
	      return Vue.prototype.$loading(tips, type);
	    };
	  });
	};
	
	module.exports = Toast;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCookie = exports.login = exports.isWeixin = exports.WXauthorize = undefined;
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _api = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isLogin = false;
	
	
	var config = {
	  AppSecret: 'ee7cc693908469ba95fd465a6ebd87dd',
	  coverSuffix: '-newslist7.0.4',
	  coverBigSuffix: '',
	  AppID: "wx89cd743f8cdc3eec",
	  wsStatisUrl: 'https://wscdn.ql1d.com'
	};
	
	function isWeixin() {
	  var ua = navigator.userAgent.toLowerCase();
	  if (ua.match(/MicroMessenger/i) == "micromessenger") {
	    return true;
	  } else {
	    return false;
	  }
	};
	
	function login() {
	  var CODE = GetQueryString("code");
	  var STATE = GetQueryString("state");
	  if (STATE !== null) {
	    if (CODE === null) {
	      clearCookie('token');
	    } else {
	      var params = {
	        "code": CODE
	      };
	
	      (0, _api.getAccessToken)(params).then(function (res) {
	        if (res.data.rc == 0) {
	          var accessInfo = res.data.data;
	
	          var params1 = {
	            "openId": accessInfo.openid,
	            "unionId": accessInfo.unionid,
	            "accessToken": accessInfo.access_token
	          };
	          (0, _api.getToken)(params1).then(function (re) {
	            if (re.data.rc == 0) {
	              var tokenInfo = re.data.data;
	              setCookie('token', tokenInfo.tokenId, 7);
	
	              window.location.href = window.location.href.split('&')[0];
	            } else {
	              toast('授权失败', 2000);
	            }
	          });
	        } else {
	          toast('授权失败', 2000);
	        }
	      });
	    }
	  }
	};
	
	function WXauthorize() {
	  if (isWeixin()) {
	    if (!getCookie('token')) {
	      var origin_state = Math.floor(Math.random() * 1000000);
	      var SCOPE = "snsapi_userinfo";
	      var currentURL = window.location.href;
	      window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + config.AppID + '&redirect_uri=' + encodeURI(currentURL) + '&response_type=code&scope=' + SCOPE + '&state=' + origin_state + '#wechat_redirect';
	    }
	  }
	};
	
	function setCookie(cname, cvalue, exday) {
	  var d = new Date();
	  d.setTime(d.getTime() + exday * 24 * 60 * 60 * 1000);
	  var expires = "expires=" + d.toUTCString();
	  document.cookie = cname + "=" + cvalue + "; " + expires;
	};
	
	function getCookie(name) {
	  var arr,
	      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	  if (arr = document.cookie.match(reg)) {
	    return unescape(arr[2]);
	  } else {
	    return null;
	  }
	};
	
	function clearCookie(name) {
	  setCookie(name, "", -1);
	};
	
	function GetQueryString(name) {
	  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	  var r = window.location.search.substr(1).match(reg);
	  if (r != null) return unescape(r[2]);
	  return r;
	};
	
	function toast(msg, duration) {
	  duration = isNaN(duration) ? 3000 : duration;
	  var m = document.createElement('div');
	  m.innerHTML = msg;
	  m.style.cssText = "max-width:60%;min-width: 150px;padding:0 14px;height: 40px;color: rgb(255, 255, 255);line-height: 40px;text-align: center;border-radius: 4px;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index: 999999;background: rgba(0, 0, 0,.7);font-size: 14px;";
	  document.body.appendChild(m);
	  setTimeout(function () {
	    var d = 0.5;
	    m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
	    m.style.opacity = '0';
	    setTimeout(function () {
	      document.body.removeChild(m);
	    }, d * 1000);
	  }, duration);
	};
	exports.WXauthorize = WXauthorize;
	exports.isWeixin = isWeixin;
	exports.login = login;
	exports.getCookie = getCookie;

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getWeixinAuth = undefined;
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _api = __webpack_require__(2);
	
	var _weixinJsSdk = __webpack_require__(27);
	
	var _weixinJsSdk2 = _interopRequireDefault(_weixinJsSdk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getWeixinAuth() {
	  var paramsUrl = {
	    "url": window.location.href
	  };
	  _axios2.default.get('//m.ql1d.com/get_page_config.do', { params: paramsUrl }).then(function (res) {
	    var data = res.data.data;
	    _weixinJsSdk2.default.config({
	      debug: false,
	      appId: data.appId,
	      timestamp: data.timestamp,
	      nonceStr: data.nonceStr,
	      signature: data.signature,
	      jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'onMenuShareWeibo']
	    });
	    var title = document.getElementsByTagName('title')[0].textContent;
	    var link = window.location.href;
	    _weixinJsSdk2.default.ready(function () {
	      var config = {
	        title: title + '-齐鲁壹点',
	        desc: '来自齐鲁晚报·齐鲁壹点新闻客户端',
	        link: link,
	        imgUrl: 'https://img.qiluyidian.net/shareimg20191216.jpg', success: function success() {},
	        cancel: function cancel() {},
	        fail: function fail(res) {}
	      };
	      _weixinJsSdk2.default.onMenuShareTimeline(config);
	      _weixinJsSdk2.default.onMenuShareAppMessage(config);
	      _weixinJsSdk2.default.onMenuShareQQ(config);
	      _weixinJsSdk2.default.onMenuShareQZone(config);
	      _weixinJsSdk2.default.onMenuShareWeibo(config);
	    });
	  }, function (err) {}).catch(function (error) {});
	}
	function toast(msg, duration) {
	  duration = isNaN(duration) ? 3000 : duration;
	  var m = document.createElement('div');
	  m.innerHTML = msg;
	  m.style.cssText = "max-width:60%;min-width: 150px;padding:0 14px;height: 40px;color: rgb(255, 255, 255);line-height: 40px;text-align: center;border-radius: 4px;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index: 999999;background: rgba(0, 0, 0,.7);font-size: 14px;";
	  document.body.appendChild(m);
	  setTimeout(function () {
	    var d = 0.5;
	    m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
	    m.style.opacity = '0';
	    setTimeout(function () {
	      document.body.removeChild(m);
	    }, d * 1000);
	  }, duration);
	};
	exports.getWeixinAuth = getWeixinAuth;

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/loading.cdec121.gif";

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.redirectFun = undefined;
	
	var _common = __webpack_require__(4);
	
	function redirectFun(name) {
	  var reUrl = window.location.origin + "/new/";
	  if (name == 'index') {
	    window.location.href = reUrl;
	  } else if (name == 'general') {
	    window.location.href = reUrl + 'general/' + (0, _common.getUrlParam)('id');
	  } else if (name == 'atlas') {
	    window.location.href = reUrl + 'atlas/' + (0, _common.getUrlParam)('id');
	  } else if (name == 'comment') {
	    window.location.href = reUrl + 'comment/' + (0, _common.getUrlParam)('id');
	  } else if (name == 'hotSearch') {
	    window.location.href = reUrl + 'hotSearch/' + (0, _common.getUrlParam)('id');
	  } else if (name == 'info') {
	    window.location.href = reUrl + 'info/' + (0, _common.getUrlParam)('id');
	  } else if (name == 'information') {
	    window.location.href = reUrl + 'information/' + (0, _common.getUrlParam)('id') + '/' + (0, _common.getUrlParam)('name') + '/' + (0, _common.getUrlParam)('newsId');
	  } else if (name == 'live') {
	    window.location.href = reUrl + 'living/share/' + (0, _common.getUrlParam)('id');
	  } else if (name == 'thematic') {
	    window.location.href = reUrl + 'thematic/' + (0, _common.getUrlParam)('id');
	  } else if (name == 'thinkTank') {
	    window.location.href = reUrl + 'thinkTank/' + (0, _common.getUrlParam)('id');
	  } else if (name == 'video') {
	    if ((0, _common.getUrlParam)('liveId')) {
	      window.location.href = reUrl + 'videos/' + (0, _common.getUrlParam)('id') + '/' + (0, _common.getUrlParam)('liveId');
	    } else {
	      window.location.href = reUrl + 'videos/' + (0, _common.getUrlParam)('id');
	    }
	  } else if (name == 'videoXx') {
	    if ((0, _common.getUrlParam)('liveId')) {
	      window.location.href = reUrl + 'videosXx/' + (0, _common.getUrlParam)('id') + '/' + (0, _common.getUrlParam)('liveId');
	    } else {
	      window.location.href = reUrl + 'videosXx/' + (0, _common.getUrlParam)('id');
	    }
	  } else if (name == 'ydIndex') {
	    window.location.href = reUrl + 'ydIndex/' + (0, _common.getUrlParam)('id');
	  }
	}
	
	exports.redirectFun = redirectFun;

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAA/CAQAAAD9VthUAAAB50lEQVRYCWNgGAWjYIABY5pcgkeyNy1hkluCBAMjFrsTBBLnJv5M/E9rmPAtsTmUE8P6xL6Ef7S3HAKTutAsz2VP/EIvy4HwQbIQivXJKlCJH4lHEw/TDib9BkfAywQN1JhXhcbMwwQOWqbuxA+j1o9aP2r9qPWj1o9aP2r9qPWj1o9aP2r9qPWj1o9aP2r9qPXD0Hr42M7rxMT4aBBMDPFkx9QeypbgBZEnDyZ+hVifpI5ibBo/ljG9xlBmVMsbmBKSIO6nED5NEUcPlk0Yil4m26GqiZNOvE6V0b91DEzoo5oKiZeAI45/E/6BIHT4b1WUIEKFJ3viCrD4vwSyYeLfxK8J5zPEsCSLWMWE2MTKxJrEmoT2xDdgi74n5sGjhxUo8w8yLJo0C6SKHJhUkRgeJ0wgfYayJU1N/AP2/7s4PWjoeCU+hwbd5lhuGg9uJ2olXodGwMloPgaGSJHEvVD+gzQROoyuJ4QCB1ghw6wlCRyJPZDQSHya6E6XwX0HlqReSEJLvJ/UAUwFIPbvhKZQNgb6gEiRpIuo2SzpYqIoA90AY2JM4nukiYAnKcYM9AShnIlL4dZ/T4pmoDeIFUt8Arb8b8KcJF4G+oMkz8S3QOuvx2oyDARIY01ISJwRb8wwCoYfAAA1OGqvsykIOgAAAABJRU5ErkJggg=="

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/newsError.4d1288a.png";

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/index.167474f.png";

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/newsDelete.e7cc66b.png";

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAACOlBMVEVHcEz/AADsGRroFxftGRrsGRr/AAD/AAD/AADrFBTsGRrsGBnsGBnsGBnsGRruGhrtGBvsGBrrGRrwHh7sGRrsGBrtGhoAAADsGRrtGRrtFxvsGBnsGRrsGRrMAAD/AADsGRrsExzvGRn0FRXsGRrwDw/sGRnrFBTtGhrtGRrsGBrtGhrsGRrtGBjmGhrjHBzsGBrtGhrsGBrrFBTsGRrrGhrtGBntGBrsGBndERHsGRrsGRntGBrsGBntGBvsGRruFxfqFRXvGhrsGhrrFBvsGRrtGRrtGhr/ACDvGBjtGRnrGBvsGRvsGRvsGBrmGhrsGBrsGBnrGhrwFxfsGhrnGBjsFxfqFRXuGRrpFhbrGRrtGRruGhrqGBvrGBntGBjoFxfsGRntFhrwFhbxGRnsGRrtGBntGRrrGRnuERHuFxfjDg7sGhrsGRvsGRnsFhbsGBrsGBnsGRnrGRntEhLsGRrrGBruGBrtGRnsGRrtGRrsGhrsGhrsGRnsGRrtGRruGBr1FBTsGhrsGRrtGRntGRrsGRrsGRrqGBjsFxruGBjsGBztGhrsGRruGRrsGRrrGhrtGBruGhryDRvsGBrsGBrqFRXuGBvrGhrsGRntGBrtGBnsGBrsGRrmGhrxDg7nGBjwGRntGhrwGRz/AADtGRryGxvpFhbvGBjsGRnuGRruGRvrGBrqGhrsGBrsGBvtGhrtGBv/GhrrGhr/ACTtGhrrGRrsGhrsGBrsGBrrGBnrGhrsGRvsGRqQEpKIAAAAvXRSTlMAA9gW/u8CAQQa9/3+/PkeVYn4EenGRgH1+Tj74rsFBvQbHxjtEegZoJH6Hc1UCgmxRb0N7qn9p+cP6PR08n34LAxPdibFwZ8IINVLo3rlHubxjEKfFTcYsC/P4ndgv1Uh4DoiSNn7xVsPLRJQosBEvPOkNA7s23dmru145XvO0JMZvuO2y/zqSXhJNrTkr/5aYVoTdtwlSyfK8PyepBQSIDRXUwXEExdfXOrAqDHHYItzCnQHfvZq8JToWXsi1iKQAAACJ0lEQVR42t3Ug5IkQRCA4RyjPV7btvds27Zt27Ztm/1upxq0K/eC+4cz4mtWFfSKbG0On1Dhu13tgZSi1Rd8FYLPscxmQoOilGUP8bH2PS07JucAKefexZbd7TH+iL1+vDgJ9PNWVboYmVR+oDQf/jalNDNNJjW7pp/36llfU4asyPW0BqDmbKNyyjXd1VB3JOyUVQXKHm8s61BPndeuuEFZ5JKszX/rpl9nnBlRWl9YRhRekGq9L50Y7NzmTcFVGTKqjKWQKFgpI1sUTGDRhcW5YtzaJAaLm6VsgtuyZHRZDoIddjy2zyXYF8Lj0FWCBR6P+eUEjwngsb8vwb5iPB478D8+2PBhBBcNwuPBBQQPHYnHQ/oBaRSHtdwAiNe/EIvHjUjg/M1YPDoPEk3E4lWQbMNhnC1/lYLdL3C4XnF+rklDrc2FkFrDQSe9PTP1jgJ7znXR49gzDygqekSPDzWAqnQXrd1+AtR5OimtcwtoW7GEpbHs6hLQ6WgrDS6s8+jh7GM0eJcXdPPU3rCiXC0YVbCfMbfsWsEQR+fPMMfP0z1g3APThbbuPpj2w+QY/v4GzPN+6DCy/nc5YKWlgL7t880Llnk7XXr2a7cXKPr4M1fnvt3vgSrbJ43+/NYGlHlmZSrtqS9uoM62UrFJrs95CJjS5yVWKrNzAiC7fJocqItPTgN0T/b+w+v3RQEfbN3Eso0zoWe562a/Pp4NPcxTkueB3tcv1O1vck5+MXUAAAAASUVORK5CYII="

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAABCUlEQVQoFXWRUWvCMBDHY5UOJhRxMNDpW586H4QqZQNLmv/FMfBVfGthCCIM6yxjPuzDL63WNdrcQXJ3+V3uLmFMlwZv5dv7nX9/Us/Wj0dRTMfIV7YlPumr0F9kFyJwxBoJd5fNal70TN/i5+zwjtjLyVVhhSCT/RKysJHjOuT1kbfOEKZY1SOqRgnRdtarR/Jx6EOt8zYORqQUPkCi+e4Nwlg4pLjqv3TxoN3rq+cNHKTMKMsmHVkjn2731jVB3I1OdUSIhQlSvzAqDM9Gyt06RE7EuihWOH1kt5gci33gVALiCSkW/73NelhhwztXeZ6tetshpRgJDrTFlFmGRgMnHPLBvK1H/wCW8zdcELx6SwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA5CAQAAAAmEUsOAAABhUlEQVR42u3QJaAUURTG8e8O7pGG9Yi7JSQhDfeEk0hAwh3OuYs7dNzd3SKZiOs7I/c+9907m873W7f/7ECnK2FHnS52A9/lV3mg+7TxePfjqARJRXybJFfPqB3BAadGkeStMLkABza10L9xn66GVnn+7GoLJ3InFtnazmk/PrR205FNXCkRoezTpCY1qUlNalKTmtSkJjWpSU2WJ/kf2f6d+/so9edCl06COvr9ue/ebaULgG9UrpAaRlLH5huopS0/ICmFnWDhQFKGLtX5yP8DQwg1rCstyPfOtjkLB/5Be1rD5+kO3eGn/mMfD3UkeMP5X/baL7rTenyR157tdBaVwPVd9tGNPtiDP/ljXcooHai+XvwlC/yjQYzESX8IF8QISgdqyCIX4ffnO/AM//iz7WkRAqQhhq760BH3jxMTCWHgUMP60FefcnYTQjGERrYEe+Fn3rXrj18INCONvsPXMAbpfkcD8RrBZiwaXV95I10Asww7EHLclCn0hNeLEYSky2kxLIGWnbJe2SkAAAAASUVORK5CYII="

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA5CAQAAAAmEUsOAAAD4ElEQVRYCe1YW0gUURhe8xZJCgWpUGma1+zBxSJ7MJWgHmyFHiqQLmvU9lKBRfRgwhIh9BAExXb+M7NT5tO+lRe6IILVg/SQRFuBmNpNLSGQyMuq2zDn33V2d2Z2dpzdJ8+8zfnO/53//7/zn4vFstYS3zoy+CqwEQc000a+RBvLl9BGaBaxNr6qI8MAWW86tUMXzBK/7PtN3Hy1Alk1cYt9MiTMQhe196brpvMnQRMZDSGTm+vjKlawXAX0qSHJKDT5k3QQdmZCj6oR9vmonWGpnfi0sdDTmRmFUMiHj/LwEAepo2XECjZwEq/MVJvFAm0y415wilm3itg6MZ/ylHiFfE0Pg2Z94BJywvu5GjIUJP0QNDrE1URMPQdcwQh4VT31J5FuBE3TWmWMJ5m0hwWv3ZOsjKW1ZBox3So5FUWDhEKRVvChRRbgFs00FQVIoUlp/mmoUp+ahzJSJxpyRkOKnrLwjnrSIjvtaMalZyGBICIFXUgXsxtQubyri6k0UjRKrT+F3OhP0YMUhcTU+zSitLEO6DK/bDJRwmxYGeSrUBCOOFA6mG2+KjSsNox4vfmUtJ7Z5o4ozoSUxsHLUsUIBii1V6SxxpdgBM8rBhYOxC+w0BBKuQd/nzSfEs5gYK2hgc3F37fikMvbzHbHlvCOccnLN3GgfCtRjkS63yF1LBg6t2gRZsGi5AwfmeSzmM0TJlOeVlUJzWY1H16YLJ4Byer8o81KnU+k+SxxeSYSFqMsPcrrpxG775lIyWGxO6yyIcGYBJijW80hdBdgsob969TmdA5T/cAk6TyMWmBIKnyRIIthlcJYodsHyxLlZ7UDGYOdwnkNqoZCZxPPgngAhWPRLgcDCLy8yqBeQzsvo6e8nCywg4P87hFr4yphnklR13YIN3GxvBfWG/RwA/mEPrbqGiAulkEcIBikfIzjX2sKJ3Q9wQx6eskA4RUk/BNTHaPHUeA+OBhjvTmEO8cyPRprqWrFuc5wlTF4aA3G57qR+igg6aS7QCdhIUziGM6YCFKDl/IRsl2HAraJOFyL+i4Pijt64IoLY3RHlJWYx4qldNnNWkUNEfLJBHr6lRRq7hnjiJtY9X5LywL5Id+hWMXDnfANMVO0zIxdr5xMBYTE7VUqbuQn9v+CXWadt8uCXvwLX23QAH+R8Ie73MRDkyiOYTS8DFdlhBfJUkDV0QQWu6fZeASWTg0kVdoR7wb/vCO5cXlEZJd76XtFdq88pcEzfmOcXi49yXBH4dHsvuGFrzPAdjInI1yACwl4pRXfFcYDGoX9CXoa5jZJrxzPI65v8W20Xtdb61pLXPsPTEK+cR7MwaYAAAAASUVORK5CYII="

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(9);
	
	var _common = __webpack_require__(4);
	
	var _api = __webpack_require__(2);
	
	var _authorize = __webpack_require__(11);
	
	var _weixinshare = __webpack_require__(12);
	
	exports.default = {
	    name: 'video-news',
	    components: {},
	    data: function data() {
	        return {
	            home_url: "url(" + __webpack_require__(18) + ")",
	            good_url: "url(" + __webpack_require__(115) + ")",
	            good_has_url: "url(" + __webpack_require__(36) + ")",
	            comment_url: "url(" + __webpack_require__(110) + ")",
	            share_url: "url(" + __webpack_require__(67) + ")",
	            loading_url: "url(" + __webpack_require__(13) + ")",
	            error_url: "url(" + __webpack_require__(19) + ")",
	            deleted_url: "url(" + __webpack_require__(32) + ")",
	            top_url: "url(" + __webpack_require__(16) + ")",
	            index_url: "url(" + __webpack_require__(26) + ")",
	            video: [],
	            praiseStatus: true,
	            options: [],
	            routeId: '',
	            token: '',
	            isLogin: false,
	            allShow: 0,
	            pageNo: 1,
	            pageNoNew: '',
	            videoWrap: [],
	            loading: 0,
	            arrayH: [],
	            topShow: false
	        };
	    },
	
	    watch: {},
	    mounted: function mounted() {
	        this.$nextTick(function () {
	            if (!(0, _authorize.isWeixin)()) {
	                this.$refs.tips.style.display = 'none';
	            }
	            (0, _authorize.login)();
	            if ((0, _authorize.getCookie)('token') != '' && (0, _authorize.getCookie)('token') != null) {
	                this.token = (0, _authorize.getCookie)('token');
	                this.isLogin = true;
	            } else {
	                this.isLogin = false;
	            }
	        });
	    },
	    created: function created() {
	        var _this = this;
	
	        this.routeId = (0, _common.getUrlParam)('id');
	        this.getPraiseFlag();
	        this.getVideo();
	        window.addEventListener('scroll', function () {
	            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
	            var clientHeight = document.documentElement.clientHeight;
	            var twoClient = clientHeight * 2;
	
	            for (var i = 0; i < _this.video.length; i++) {
	                var elementHeight = _this.$refs.video[i].offsetTop;
	                var top = elementHeight - scrollTop;
	                var videoH = (clientHeight - top) / 2;
	                var videoArr = document.getElementsByTagName('video');
	                if (top <= videoH && top >= 0) {
	                    videoArr[i].setAttribute("autoplay", "autoplay");
	                    videoArr[i].setAttribute("muted", "muted");
	                } else {
	                    if (videoArr[i].getAttribute("autoplay")) {
	                        videoArr[i].removeAttribute("autoplay");
	                    }
	                }
	                if ((0, _authorize.isWeixin)()) {
	                    var tips = document.getElementsByClassName('tips');
	                    _this.arrayH.unshift(scrollTop);
	                    _this.arrayH.length = 2;
	                    if (_this.arrayH[0] > _this.arrayH[1]) {
	                        if (scrollTop <= 0) {
	                            tips[0].style.display = 'block';
	                        } else {
	                            tips[0].style.display = 'none';
	                        }
	                    } else if (_this.arrayH[0] < _this.arrayH[1] || scrollTop <= 0) {
	                        tips[0].style.display = 'block';
	                    }
	                }
	
	                var scrollHeight = document.documentElement.scrollHeight;
	                if (scrollHeight <= scrollTop + clientHeight) {
	                    if (_this.videoWrap.length > _this.video.length) {
	                        _this.video.push(_this.videoWrap[_this.video.length]);
	                        _this.$nextTick(function () {
	                            var videoArr = document.getElementsByTagName('video');
	
	                            var _loop = function _loop(_i) {
	                                videoArr[_i].addEventListener('play', function () {
	                                    for (var k = 0; k < videoArr.length; k++) {
	                                        if (k != _i) {
	                                            videoArr[k].pause();
	                                        }
	                                    }
	                                });
	                            };
	
	                            for (var _i = 0; _i < videoArr.length; _i++) {
	                                _loop(_i);
	                            }
	                        });
	                    } else {
	                        _this.allShow = 1;
	                    }
	                }
	            }
	        });
	    },
	
	    methods: {
	        getPraiseFlag: function getPraiseFlag() {
	            var _this2 = this;
	
	            if ((0, _authorize.getCookie)('token') != '' && (0, _authorize.getCookie)('token') != null) {
	                this.token = (0, _authorize.getCookie)('token');
	            } else {
	                this.token = '';
	            }
	            var params = {
	                token: this.token,
	                newsid: this.routeId
	            };
	            (0, _api.praiseFlag)(params).then(function (res) {
	                if (res && res.data.rc == 0) {
	                    if (res.data.flag == '-1') {
	                        _this2.videoSnap = true;
	                    }
	                }
	            });
	        },
	        getVideo: function getVideo() {
	            var _this3 = this;
	
	            this.video = [];
	            this.videoWrap = [];
	            var id = '';
	            if ((0, _common.getUrlParam)('liveId')) {
	                id = (0, _common.getUrlParam)('liveId') + ',' + this.routeId;
	            } else {
	                id = this.routeId;
	            }
	            var params = {
	                "newsid": id,
	                "pageNo": 1,
	                "pageSize": 20
	            };
	            (0, _api.videoDetails)(params).then(function (res) {
	                if (res && res.data.rc == 0) {
	                    _this3.loading = -1;
	                    _this3.topShow = true;
	                    document.title = res.data.data[0].title;
	                    (0, _weixinshare.getWeixinAuth)();
	
	                    for (var i = 0; i < res.data.data.length; i++) {
	                        _this3.videoWrap.push(res.data.data[i]);
	
	                        _this3.videoWrap[i].praiseStatus = true;
	                    }
	                    if (_this3.videoWrap.length > 4) {
	                        for (var n = 0; n < 4; n++) {
	                            _this3.video.push(_this3.videoWrap[n]);
	                        }
	                    } else {
	                        for (var _n = 0; _n < _this3.videoWrap.length; _n++) {
	                            _this3.video.push(_this3.videoWrap[_n]);
	                        }
	                    }
	                    _this3.$nextTick(function () {
	                        var videoArr = document.getElementsByTagName('video');
	                        for (var _i2 = 1; _i2 < videoArr.length; _i2++) {
	                            if (videoArr[_i2].getAttribute("autoplay")) {
	                                videoArr[_i2].removeAttribute("autoplay");
	                            }
	                        }
	
	                        if (!(0, _authorize.isWeixin)()) {
	                            document.getElementsByClassName('videoWraper')[0].style.paddingTop = '6px';
	                        }
	
	                        var _loop2 = function _loop2(_i3) {
	                            videoArr[_i3].addEventListener('play', function () {
	                                for (var k = 0; k < videoArr.length; k++) {
	                                    if (k != _i3) {
	                                        videoArr[k].pause();
	                                    }
	                                }
	                            });
	                        };
	
	                        for (var _i3 = 0; _i3 < videoArr.length; _i3++) {
	                            _loop2(_i3);
	                        }
	                    });
	                } else if (res && res.data.rc == -1) {
	                    _this3.loading = 2;
	                } else {
	                    _this3.loading = 1;
	                }
	            });
	        },
	        goCommentPage: function goCommentPage(val) {
	            if (this.isLogin) {
	                if ((0, _common.getUrlParam)('mwb')) {
	                    location.href = _common.configData.jumpUrl + '/comment.html?id=' + val + '&mwb=' + 'mobi';
	                } else {
	                    location.href = _common.configData.jumpUrl + '/comment.html?id=' + val;
	                }
	            } else {
	                (0, _authorize.WXauthorize)();
	            }
	        },
	        snap: function snap(newsId, index) {
	            var _this4 = this;
	
	            if (this.isLogin) {
	                var params = {
	                    "token": this.token,
	                    "newsid": newsId
	                };
	                (0, _api.newsSnap)(params).then(function (res) {
	                    if (res.data.rc == 0) {
	                        if (res.data.data.praiseDec == '-1') {
	                            _this4.$toast.center('点赞已满');
	                            _this4.video[index].praiseStatus = false;
	                        } else {
	                            _this4.video[index].praiseStatus = false;
	                            _this4.video[index].praisecount++;
	                        }
	                    }
	                });
	            } else {
	                (0, _authorize.WXauthorize)();
	            }
	        },
	        hasSnap: function hasSnap(newsId, index) {
	            var _this5 = this;
	
	            if (this.isLogin) {
	                var params = {
	                    "token": this.token,
	                    "newsid": newsId
	                };
	                (0, _api.newsSnap)(params).then(function (res) {
	                    if (res.data.rc == 0) {
	                        if (res.data.data.praiseDec == '-1') {
	                            _this5.$toast.center('点赞已满');
	                            _this5.video[index].praiseStatus = false;
	                        } else {
	                            _this5.video[index].praiseStatus = false;
	                            _this5.video[index].praisecount++;
	                        }
	                    }
	                });
	            } else {
	                (0, _authorize.WXauthorize)();
	            }
	        },
	        down: function down() {
	            var u = navigator.userAgent;
	            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
	            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
	            if (isAndroid) {
	                window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.com.qlwb.qiluyidian';
	            } else if (isiOS) {
	                window.location.href = 'https://itunes.apple.com/cn/app/qi-lu-yi-dian-ti-yu-gong-jiao/id903816468?mt=8';
	            }
	        },
	        goHome: function goHome() {
	            if ((0, _common.getUrlParam)('mwb')) {
	                location.href = _common.configData.jumpUrl + '/mobiIndex.html';
	            } else {
	                location.href = _common.configData.jumpUrl + '/index.html';
	            }
	        },
	        toTop: function toTop() {
	            document.body.scrollTop = 0;
	            document.documentElement.scrollTop = 0;
	        }
	    }
	};

/***/ }),

/***/ 286:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(287)
	__webpack_require__(286)
	
	/* script */
	__vue_exports__ = __webpack_require__(213)
	
	/* template */
	var __vue_template__ = __webpack_require__(415)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5e555b90"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "video-news"
	  }, [_c('img', {
	    staticStyle: {
	      "z-index": "-10",
	      "position": "absolute"
	    },
	    attrs: {
	      "src": "https://img.qiluyidian.net/shareimg20191216.jpg",
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    ref: "tips",
	    staticClass: "tips clearfix"
	  }, [_c('span', {
	    staticClass: "homeIcon",
	    style: ({
	      backgroundImage: _vm.home_url,
	      backgroundSize: '100%'
	    }),
	    on: {
	      "click": _vm.goHome
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "rightLine"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "slogon"
	  }, [_vm._v("齐鲁晚报官方APP")]), _vm._v(" "), _c('span', {
	    staticClass: "openApp",
	    on: {
	      "click": _vm.down
	    }
	  }, [_vm._v("打开")])]), _vm._v(" "), (_vm.loading == 0) ? _c('div', {
	    staticClass: "loading",
	    style: ({
	      backgroundImage: _vm.loading_url,
	      backgroundSize: '20%'
	    })
	  }) : (_vm.loading == 1) ? _c('div', {
	    staticClass: "loading",
	    style: ({
	      backgroundImage: _vm.error_url,
	      backgroundSize: '50%'
	    })
	  }) : (_vm.loading == 2) ? _c('div', {
	    staticClass: "loading",
	    style: ({
	      backgroundImage: _vm.deleted_url,
	      backgroundSize: '50%'
	    })
	  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.video), function(item, index) {
	    return _c('div', {
	      ref: "video",
	      refInFor: true,
	      staticClass: "videoWraper",
	      class: {
	        videoWraperF: index == 0
	      }
	    }, [_c('div', {
	      staticClass: "videoAuthor clearfix"
	    }, [(item.userImg) ? _c('img', {
	      attrs: {
	        "src": item.userImg,
	        "alt": ""
	      }
	    }) : _c('img', {
	      attrs: {
	        "src": __webpack_require__(6),
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('span', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('span', {
	      staticClass: "time"
	    }, [_vm._v(_vm._s(item.publishtime))])]), _vm._v(" "), _c('div', {
	      staticClass: "video"
	    }, [_c('video', {
	      attrs: {
	        "src": item.videourl,
	        "height": "100%",
	        "width": "100%",
	        "poster": item.headimg,
	        "x5-playsinline": "",
	        "preload": "none",
	        "playsinline": "",
	        "webkit-playsinline": "",
	        "controls": "controls",
	        "loop": "loop"
	      }
	    })]), _vm._v(" "), _c('p', {
	      staticClass: "videoTitle"
	    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
	      staticClass: "editor clearfix"
	    }, [(item.columnName) ? _c('span', {
	      staticClass: "tags"
	    }, [_vm._v(_vm._s(item.columnName))]) : (item.ownername) ? _c('span', {
	      staticClass: "tags"
	    }, [_vm._v(_vm._s(item.ownername))]) : (item.source) ? _c('span', {
	      staticClass: "tags"
	    }, [_vm._v(_vm._s(item.source))]) : _vm._e(), _vm._v(" "), (item.praiseStatus) ? _c('span', {
	      staticClass: "good clearfix",
	      on: {
	        "click": function($event) {
	          return _vm.snap(item.newsId, index)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "goodIcon",
	      style: ({
	        backgroundImage: _vm.good_url,
	        backgroundSize: 'contain'
	      })
	    }), _vm._v(" "), (item.praisecount != '' && item.praisecount != 0) ? _c('span', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.praisecount))]) : _vm._e()]) : _c('span', {
	      staticClass: "good clearfix",
	      on: {
	        "click": function($event) {
	          return _vm.hasSnap(item.newsId, index)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "goodIcon",
	      style: ({
	        backgroundImage: _vm.good_has_url,
	        backgroundSize: 'contain'
	      })
	    }), _vm._v(" "), (item.praisecount != '' && item.praisecount != 0) ? _c('span', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.praisecount))]) : _vm._e()]), _vm._v(" "), _c('span', {
	      staticClass: "comment clearfix",
	      on: {
	        "click": function($event) {
	          return _vm.goCommentPage(item.newsId)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "commentIcon",
	      style: ({
	        backgroundImage: _vm.comment_url,
	        backgroundSize: 'contain'
	      })
	    }), _vm._v(" "), (item.commentcount != '' && item.commentcount != 0) ? _c('span', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.commentcount))]) : _vm._e()])])])
	  }), _vm._v(" "), (_vm.allShow == 1) ? _c('div', {
	    staticClass: "hotNewsAll"
	  }, [_c('div', {
	    staticClass: "appGoWrapper",
	    on: {
	      "click": function($event) {
	        return _vm.down()
	      }
	    }
	  }, [_c('p', {
	    staticClass: "openAppGo"
	  }, [_vm._v("打开壹点APP，查看更多视频")])])]) : _vm._e(), _vm._v(" "), (_vm.topShow) ? _c('div', {
	    staticClass: "toTop"
	  }, [_c('span', {
	    staticClass: "index",
	    style: ({
	      backgroundImage: _vm.index_url,
	      backgroundSize: 'contain'
	    }),
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.goHome.apply(null, arguments)
	      }
	    }
	  })]) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/module/video.c42ae5ea35d292b95372.js